"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_utils_1 = require("../../../../utils/dom-utils");
const showMoreBTN = (0, dom_utils_1.elementId)('showMore');
const partners = document.querySelector('.partners-section');
const partnersGroup = (0, dom_utils_1.queryAll)('.partners__group');
document.addEventListener('DOMContentLoaded', () => {
    if (partners) {
        let currentGroup = parseInt(showMoreBTN.dataset.currentGroup || '1', 10);
        showMoreBTN.addEventListener('click', () => {
            if (currentGroup < partnersGroup.length) {
                const nextGroup = partnersGroup[currentGroup];
                nextGroup.style.display = 'flex';
                currentGroup++;
                showMoreBTN.dataset.currentGroup = currentGroup.toString();
            }
            currentGroup >= partnersGroup.length ? showMoreBTN.style.display = 'none' : '';
        });
    }
});
